export default __webpack_public_path__ + "static/media/pinon.f419be17.svg";